import { useCallback } from 'react';
import { selectEmirates, useAppInitStore } from '../../stores';

export const useEmirates = () => {
	const emirates = useAppInitStore(selectEmirates);

	const getEmirateById = useCallback(
		(emirateId: number) => emirates.find((emirate) => emirate.id === emirateId),
		[emirates]
	);

	return { emirates, getEmirateById };
};
